var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.event
    ? _c(
        "v-container",
        {
          staticClass: "event",
          class: [
            { "pre-match": !_vm.liveEvent },
            { "live-match": _vm.liveEvent }
          ],
          attrs: { fluid: "" }
        },
        [
          _vm.isEventStreamable
            ? [
                _c(
                  "div",
                  {
                    class: [
                      "stream-eventinfo-switcher",
                      { "stream-active": _vm.isLiveStreamVisible }
                    ]
                  },
                  [
                    _c(
                      "span",
                      {
                        class: ["tab", { active: !_vm.isLiveStreamVisible }],
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.showEventInfo()
                          }
                        }
                      },
                      [
                        _c("v-icon", [_vm._v("info_outline")]),
                        _vm._v("Back to Event Info")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class: [
                          "tab",
                          { active: _vm.isLiveStreamVisible },
                          { disabled: !_vm.isLiveEventPage }
                        ],
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.showLiveStream()
                          }
                        }
                      },
                      [
                        _c("v-icon", [_vm._v("play_arrow")]),
                        _vm._v("Watch Live")
                      ],
                      1
                    )
                  ]
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLiveStreamVisible || !_vm.isLiveEventPage || !_vm.liveStream
            ? [
                _vm.bettingDataMatcherinitiallLoad && _vm.betRadarId
                  ? [
                      !_vm.mobileBigAndBelow &&
                      (_vm.idFwMarketgroup || _vm.liveEvent) &&
                      _vm.isFastSwitchEnabled
                        ? _c("div", { staticClass: "fast_switch_holder" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.event.fosportname || _vm.event.sportname
                                ) +
                                " "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "fast_swich_arrow_down",
                                on: { click: _vm.toggleFastSwitch }
                              },
                              [_c("v-icon", [_vm._v("keyboard_arrow_down")])],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.betRadarWidgetVersion === "V1"
                        ? _c("bet-radar-widget", {
                            attrs: {
                              betradarid: _vm.betRadarId,
                              isLive:
                                _vm.liveEvent && _vm.liveEvent.idfoevent
                                  ? true
                                  : false
                            }
                          })
                        : _c("bet-radar-widget-v2", {
                            attrs: { betradarId: _vm.betRadarId }
                          })
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticClass: "event_header",
                          class: "sport-" + _vm.event.idfosporttype
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "competition-live",
                              class: [
                                { "pre-match": !_vm.liveEvent },
                                { "live-match": _vm.liveEvent }
                              ]
                            },
                            [
                              _c(
                                "section",
                                {
                                  staticClass: "competition-name",
                                  class: {
                                    "competitionname-betradar-id":
                                      _vm.betRadarId
                                  }
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        (_vm.event && _vm.event.fosportname) ||
                                          _vm.event.sportname
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  !_vm.mobileBigAndBelow &&
                                  (_vm.idFwMarketgroup || _vm.liveEvent) &&
                                  _vm.isFastSwitchEnabled
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "fast_swich_arrow_down",
                                          on: { click: _vm.toggleFastSwitch }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("keyboard_arrow_down")
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.liveEvent
                            ? _c(
                                "div",
                                { staticClass: "event-info" },
                                [
                                  _c("live-event-info", {
                                    attrs: {
                                      event: _vm.liveEvent,
                                      page: "'event'"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.liveEvent
                            ? _c(
                                "div",
                                { staticClass: "event-info" },
                                [
                                  _vm.event.participantname_away &&
                                  _vm.event.participantname_home
                                    ? [
                                        _vm.brandLayout !== "generic" &&
                                        _vm.brandKey !== "sb"
                                          ? _c(
                                              "section",
                                              { staticClass: "parent" },
                                              [
                                                _c(
                                                  "section",
                                                  {
                                                    staticClass:
                                                      "child child-left"
                                                  },
                                                  [
                                                    _vm.isbig3event
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "team-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.event
                                                                  .participantname_away
                                                              ) + " "
                                                            ),
                                                            _vm.isPitcherVisible
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "smaller"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "lowercase"
                                                                        )(
                                                                          _vm
                                                                            .event
                                                                            .awaypitchername
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "team-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.event
                                                                  .participantname_home
                                                              ) + " "
                                                            ),
                                                            _vm.isPitcherVisible
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "smaller"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "lowercase"
                                                                        )(
                                                                          _vm
                                                                            .event
                                                                            .homepitchername
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "section",
                                                  {
                                                    staticClass:
                                                      "child child-center"
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "span",
                                                        { staticClass: "time" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("moment")(
                                                                _vm.event
                                                                  .tsrealstart,
                                                                _vm.dateFormats
                                                                  .longTime
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "day" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("moment")(
                                                                _vm.event
                                                                  .tsrealstart,
                                                                _vm.dateFormats
                                                                  .dayAndMonth
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "section",
                                                  {
                                                    staticClass:
                                                      "child child-right"
                                                  },
                                                  [
                                                    _vm.isbig3event
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "team-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.event
                                                                  .participantname_home
                                                              ) + " "
                                                            ),
                                                            _vm.isPitcherVisible
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "smaller"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "lowercase"
                                                                        )(
                                                                          _vm
                                                                            .event
                                                                            .homepitchername
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "team-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.event
                                                                  .participantname_away
                                                              ) + " "
                                                            ),
                                                            _vm.isPitcherVisible
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "smaller"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "lowercase"
                                                                        )(
                                                                          _vm
                                                                            .event
                                                                            .awaypitchername
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.brandLayout === "generic" ||
                                        _vm.brandKey === "sb"
                                          ? _c(
                                              "section",
                                              { staticClass: "parent" },
                                              [
                                                _vm.isbig3event
                                                  ? _c(
                                                      "section",
                                                      {
                                                        staticClass:
                                                          "child child-left"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "team-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.event
                                                                  .participantname_away
                                                              ) + " "
                                                            ),
                                                            _vm.isPitcherVisible
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "smaller"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "lowercase"
                                                                        )(
                                                                          _vm
                                                                            .event
                                                                            .awaypitchername
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "team-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.event
                                                                  .participantname_home
                                                              ) + " "
                                                            ),
                                                            _vm.isPitcherVisible
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "smaller"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "lowercase"
                                                                        )(
                                                                          _vm
                                                                            .event
                                                                            .homepitchername
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "section",
                                                      {
                                                        staticClass:
                                                          "child child-left"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "team-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.event
                                                                  .participantname_home
                                                              ) + " "
                                                            ),
                                                            _vm.isPitcherVisible
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "smaller"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "lowercase"
                                                                        )(
                                                                          _vm
                                                                            .event
                                                                            .homepitchername
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "team-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.event
                                                                  .participantname_away
                                                              ) + " "
                                                            ),
                                                            _vm.isPitcherVisible
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "smaller"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "lowercase"
                                                                        )(
                                                                          _vm
                                                                            .event
                                                                            .awaypitchername
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "section",
                                                  {
                                                    staticClass:
                                                      "child child-right"
                                                  },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "span",
                                                        { staticClass: "day" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("moment")(
                                                                _vm.event
                                                                  .tsrealstart,
                                                                _vm.dateFormats
                                                                  .dayAndMonthUS
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "time" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f("moment")(
                                                                _vm.event
                                                                  .tsrealstart,
                                                                _vm.dateFormats
                                                                  .longTime
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.event.participantname_away ||
                                  !_vm.event.participantname_home
                                    ? _c("h3", [_vm._v(_vm._s(_vm.event.name))])
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      )
                    ]
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isLiveStreamVisible
            ? [
                _vm.isLoggedIn
                  ? [
                      !_vm.sisStreamData.error
                        ? _c(
                            "div",
                            { staticClass: "video-streaming" },
                            [
                              _c("THEOPlayer", {
                                attrs: {
                                  playerLicense:
                                    _vm.sisStreamData.playerLicense,
                                  src: _vm.sisStreamData.hespSrc,
                                  subscriberToken:
                                    _vm.sisStreamData.subscribeToken
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "video-streaming-error-message" },
                            [
                              _c("h2", [
                                _vm._v(
                                  _vm._s(
                                    _vm.sisStreamData.error
                                      ? _vm.sisStreamData.error
                                      : "Video stream not available at the moment."
                                  )
                                )
                              ])
                            ]
                          )
                    ]
                  : _c(
                      "div",
                      { staticClass: "video-streaming-error-message" },
                      [
                        _c("h2", [
                          _vm._v("Please log in to watch video stream!")
                        ])
                      ]
                    )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isFlashBettingEnabled &&
          _vm.liveEvent &&
          _vm.liveEvent.mtcgflags &&
          _vm.liveEvent.mtcgflags.includes("FlashBetting")
            ? [
                _c(
                  "div",
                  [
                    _c("FlashBetting", {
                      attrs: {
                        flashBettingMarkets: _vm.flashBettingMarkets,
                        mode: "event"
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.availableFeatureTabs && _vm.availableFeatureTabs.length > 0
            ? _c("feature-tabs-widget", {
                attrs: {
                  availableFeatureTabs: _vm.availableFeatureTabs,
                  eventId: _vm.idfoevent,
                  displayMode: "carousel"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          (_vm.xtremepushWebInitialized || _vm.xtremePushEnabledMobile) &&
          _vm.xtremepushOnSiteEnabled &&
          _vm.xtremepushInlineContent
            ? _c("xtremepush-inline-content", {
                attrs: {
                  sportType: _vm.event.idfosporttype,
                  section: "under_coupon_tabs"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "v-tabs-wrapper clearfix",
              class: { "betradar-id": _vm.betRadarId }
            },
            [
              _c(
                "v-tabs",
                {
                  class: [
                    "eventmarketgroups-tab",
                    { "have-bet-radar-id": _vm.betRadarId },
                    {
                      with_more_btn:
                        _vm.eventmarketgroups.length > _vm.numberOfTabs
                    }
                  ]
                },
                [
                  _vm.isRecommendedMarketsEnabled
                    ? _c(
                        "v-tab",
                        {
                          class: [
                            "sport",
                            "tab",
                            {
                              active:
                                _vm.selectedIDFWMarkettypeclassGroup ===
                                "recommended"
                            }
                          ],
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.selectEMG("recommended")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Page.Event.RecommendedTab")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.eventmarketgroups, function(
                    eventmarketgroup,
                    index
                  ) {
                    return ((index <= _vm.numberOfTabs - 1 &&
                      !_vm.mobileBigAndBelow) ||
                      (index >= 0 && _vm.mobileBigAndBelow)) &&
                      eventmarketgroup.name
                      ? _c(
                          "v-tab",
                          {
                            key: eventmarketgroup.idfwmarkettypeclassgroup,
                            class: [
                              "sport",
                              "tab",
                              {
                                active:
                                  eventmarketgroup.idfwmarkettypeclassgroup ===
                                  _vm.selectedIDFWMarkettypeclassGroup
                              }
                            ],
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.selectEMG(
                                  eventmarketgroup.idfwmarkettypeclassgroup
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(eventmarketgroup.name))]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.eventmarketgroups.length > _vm.numberOfTabs &&
                  !_vm.mobileBigAndBelow
                    ? _c(
                        "v-menu",
                        {
                          staticClass: "v-tabs__div",
                          attrs: {
                            "offset-y": "",
                            "max-width": "320",
                            "min-width": "212",
                            left: true,
                            bottom: true,
                            origin: "center",
                            "content-class": "menu_top_arrow_right"
                          }
                        },
                        [
                          !_vm.mobileBigAndBelow
                            ? _c(
                                "a",
                                {
                                  staticClass: "more_tabs",
                                  class: _vm.moreButtonState,
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c("span", [_vm._v(_vm._s(_vm.$t("More")))]),
                                  _vm._v(" "),
                                  _vm.moreButtonState
                                    ? _c("v-icon", [_vm._v("expand_less")])
                                    : _c("v-icon", [_vm._v("expand_more")])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            _vm._l(_vm.eventmarketgroups, function(
                              eventmarketgroup,
                              index
                            ) {
                              return index > _vm.numberOfTabs - 1
                                ? _c(
                                    "v-list-tile",
                                    {
                                      key: index,
                                      class: [
                                        "sporttab-li",
                                        {
                                          active:
                                            eventmarketgroup.idfwmarkettypeclassgroup ===
                                            _vm.selectedIDFWMarkettypeclassGroup
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.selectEMG(
                                            eventmarketgroup.idfwmarkettypeclassgroup
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "list_title" },
                                        [_vm._v(_vm._s(eventmarketgroup.name))]
                                      ),
                                      _c("icon", {
                                        attrs: {
                                          name: "icon-tick",
                                          colorName: "blue"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isMarketsOrderOnEventPageEnabled
            ? _c("div", { staticClass: "toggle-container" }, [
                _vm._v("\n    " + _vm._s(_vm.$t("Order.By")) + "\n    "),
                _c(
                  "div",
                  {
                    staticClass: "order-toggle",
                    style: { "--active-index": _vm.activeIndex }
                  },
                  _vm._l(_vm.marketsOrderOptions, function(option) {
                    return _c(
                      "div",
                      {
                        key: option.value,
                        staticClass: "order-toggle__option",
                        class: {
                          "order-toggle__option--active":
                            _vm.order === option.value
                        },
                        on: {
                          click: function($event) {
                            return _vm.setOrder(option.value)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedEventMarketGroup
            ? _c(
                "div",
                {
                  key: _vm.selectedEventMarketGroup.idfwmarkettypeclassgroup,
                  staticClass: "eventmarketgroup marketgroup",
                  class: [
                    { "betradar-id": _vm.betRadarId },
                    _vm.className,
                    {
                      "order-toggle-enabled":
                        _vm.isMarketsOrderOnEventPageEnabled
                    }
                  ]
                },
                [
                  _vm.displayAllGamePeriodsAsBig3
                    ? _vm._l(_vm.filteredBig3MarketsPerPeriod, function(
                        gamePeriodMarkets,
                        key
                      ) {
                        return _vm.filteredBig3MarketsPerPeriod
                          ? _c("markets", {
                              key: key,
                              attrs: {
                                markets: gamePeriodMarkets,
                                event: _vm.event,
                                diplayOnPage: "live-single-event",
                                isLiveEventPage: _vm.isLiveEventPage,
                                pricechangehighlight: _vm.isLiveEventPage
                              }
                            })
                          : _vm._e()
                      })
                    : [
                        _vm.filteredBig3MarketsWholeGame
                          ? _c("markets", {
                              attrs: {
                                markets: _vm.filteredBig3MarketsWholeGame,
                                event: _vm.event,
                                diplayOnPage: "live-single-event",
                                isLiveEventPage: _vm.isLiveEventPage,
                                pricechangehighlight: _vm.isLiveEventPage
                              }
                            })
                          : _vm._e()
                      ],
                  _vm._v(" "),
                  _vm._l(_vm.filteredNonBig3NonAltMarkets, function(
                    market,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        key: index,
                        class: [
                          "event-market-header",
                          {
                            last:
                              index ===
                              _vm.filteredNonBig3NonAltMarkets.length - 1
                          },
                          { "available-for-bb": _vm.isBBenabled && market.BB }
                        ],
                        style: { order: market.order }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "market-name",
                            class: [
                              {
                                "expanded-market":
                                  (_vm.expandedMarkets[
                                    _vm.selectedEventMarketGroup
                                      .idfwmarkettypeclassgroup +
                                      "-" +
                                      market.idfomarket
                                  ] &&
                                    market.order !== 0) ||
                                  (_vm.expandedMarkets[
                                    _vm.selectedEventMarketGroup
                                      .idfwmarkettypeclassgroup +
                                      "-" +
                                      market.idfomarket
                                  ] !== false &&
                                    market.order === 0)
                              }
                            ],
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toggleExpandMarket(
                                  _vm.selectedEventMarketGroup
                                    .idfwmarkettypeclassgroup +
                                    "-" +
                                    market.idfomarket,
                                  market.order,
                                  market.idfomarket
                                )
                              }
                            }
                          },
                          [
                            _c("h4", { staticClass: "market-name-title" }, [
                              _vm._v(_vm._s(market.name))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "flex icon-span" },
                              [
                                _c("sgp-tag", {
                                  attrs: {
                                    markets: _vm.ksPreProcessMarkets(
                                      [market],
                                      _vm.event
                                    ),
                                    isLive: _vm.isLiveEventPage
                                  }
                                }),
                                _vm._v(" "),
                                _vm.isBBenabled && market.BB
                                  ? _c("span", {
                                      staticClass: "available-for-bb"
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("v-icon", [
                                  _vm._v(
                                    _vm._s(
                                      market.idfomarket === _vm.firstMarketKey
                                        ? "expand_less"
                                        : "expand_more"
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        (market.order === 0 &&
                          _vm.expandedMarkets[
                            _vm.selectedEventMarketGroup
                              .idfwmarkettypeclassgroup +
                              "-" +
                              market.idfomarket
                          ] !== false) ||
                        _vm.expandedMarkets[
                          _vm.selectedEventMarketGroup
                            .idfwmarkettypeclassgroup +
                            "-" +
                            market.idfomarket
                        ]
                          ? _c("markets", {
                              attrs: {
                                markets: [market],
                                event: _vm.event,
                                diplayOnPage: "live-single-event",
                                isLiveEventPage: _vm.isLiveEventPage,
                                pricechangehighlight: _vm.isLiveEventPage
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.groupAltMarkets, function(group, index) {
                    return _c(
                      "div",
                      {
                        staticClass: "event-market-header alt-markets",
                        style: { order: group.order }
                      },
                      [
                        _c("alt-markets", {
                          attrs: {
                            markets: group.markets,
                            event: _vm.event,
                            diplayOnPage: "live-single-event",
                            isLiveEventPage: _vm.isLiveEventPage,
                            pricechangehighlight: _vm.isLiveEventPage,
                            expandFirst: group.order === 0
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("player-props-markets", {
                    attrs: {
                      markets: _vm.filteredNonBig3PlayerPropsMarkets,
                      event: _vm.event,
                      diplayOnPage: "live-single-event",
                      isLiveEventPage: _vm.isLiveEventPage,
                      pricechangehighlight: _vm.isLiveEventPage,
                      expandFirst: !_vm.filteredNonBig3NonPlayerPropsMarkets
                        .length
                    }
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.marketsAvailable && !_vm.isRecommendedMarketsLoading
            ? _c("div", { staticClass: "no-markets" }, [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.$t("Sports.NoAvailableMarkets")) +
                    "\n  "
                )
              ])
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c6c92d10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6c92d10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/event.vue
// module id = null
// module chunks = 